import React, { useEffect, useState } from "react";
import moment from "moment";

import { getUserMonthlyActivity } from "../../../APIS"; // <-- API for single user data

const ActivityLogs = () => {
  const query = new URLSearchParams(window.location.search);
  const id = query.keys().next().value;

  const [data, setData] = useState({});
  const [month, setMonth] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  const token = userDetails?.token;

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getUserMonthlyActivity(id, token);

      if (response.success && response.data) {
        setMonth(response.month);
        setData(response.data);
      } else {
        setData({});
      }
    } catch (err) {
      setError("Failed to load activity logs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title m-0">
          Activity Logs - {moment(month).format("MMM YYYY")}
        </h4>
      </div>

      <div className="card-body">
        {loading && <p className="text-center fw-bold">Loading...</p>}
        {error && <p className="text-danger text-center">{error}</p>}

        {!loading && Object.keys(data).length === 0 && (
          <p className="text-center">No activity found.</p>
        )}

        {Object.keys(data).length > 0 && (
          <div className="table-responsive">
            <table className="table table-striped align-middle text-center">
              <thead>
                <tr>
                  {/* <th>Sr / Date</th> */}
                  {Object.keys(data).map((date, index) => (
                    <th key={index} style={{ minWidth: "200px" }}>
                      {
                        // new Date(date).toLocaleDateString("en-GB")
                        moment(date).format("DD MMM YYYY")
                      }
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {Array.from({ length: 5 }).map((_, rowIndex) => (
                  <tr key={rowIndex}>
                    {/* <td className="fw-bold">{rowIndex + 1}</td> */}
                    {Object.values(data).map((activities, colIndex) => (
                      <td
                        key={colIndex}
                        style={{
                          textAlign: "left",
                          whiteSpace: "pre-line",
                          verticalAlign: "top",
                        }}
                      >
                        {activities[rowIndex] || ""}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityLogs;
